import { AdminsPageLayout } from "../AdminsPageLayout/AdminsPageLayout";

export const AdminRolesPage = () => (
  <AdminsPageLayout selector="roles">
    <div>todo: admin roles</div>
  </AdminsPageLayout>
);
